import { useEffect, useState } from "react";
import { Accordion, AccordionItem, AccordionItemHeading, AccordionItemButton, AccordionItemPanel, } from 'react-accessible-accordion';
import { Link, useLocation, useNavigate } from "react-router-dom";
import httpClient from "../../HTTPService";
import noimage from "../../assets/noimage.jpg"
import moment from "moment";
import Icon, { FontAwesome, Feather } from 'react-js-vector-icons';
import '../FormManagement/FormManagement.css'
// import {icon}
function MemberProfileView() {
    const location = useLocation()
    const queryParams = new URLSearchParams(location.search); // Parse query string
    const id = queryParams.get('id');
    const [accouuntDetaila, setaccountDetails] = useState()
    const [businessProfiles, setBusinessProfiles] = useState([])
    const [bank_details, setBankdetails] = useState()
    const [memberSubDetails, setmembersSubDetails] = useState(null)
    const [subscriptionList, setSubscriptionList] = useState([])
    const [profileSubsciption, setProfileSubsCription] = useState([])
    const navigate = useNavigate()
    const [uplineData, setUplineData] = useState([])

    const [memberAddedlist, setmemberAddedprofile] = useState([])

    useEffect(() => {
        getMembersDetails()
        getUplineData()
        fetchmemberAddedProfil()
    }, [])
    // useEffect(() => {
    //     console.log(location, 'location')
    // }, [location])
    const getMembersDetails = async () => {
        try {
            const result = await httpClient.post('/admin/members-profle-view', { id: id }, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            })
            if (result.status == 200) {
                console.log(result.data, 'data..')
                setmembersSubDetails(result.data?.data?.current_membership)
                setaccountDetails(result.data.data)
                setBusinessProfiles(result.data?.profiles)
                setBankdetails(result.data?.bank_accounts)
                setSubscriptionList(result?.data?.profile_view_subscriptions)
                setProfileSubsCription(result?.data?.subscriptions)
                // setmemberlist(result?.data?.data)
            }

        } catch (error) {
            //   toast.error(error.message)
        }
    }

    const getUplineData = async () => {
        try {
            const result = await httpClient.post('/admin/depth-upline-member-list', {

                user_id: id,

            }, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            })

            if (result.status === 200) {
                let week_arr = []
                console.log(result.data.data, 'data..')
                // setTotalCount(result?.data.total_count)
                setUplineData(result?.data?.data)

                // setweeklyData(result?.data?.weekly_report_data)
            }

        } catch (error) {
            //   toast.error(error.message)
        }
    }


    const fetchmemberAddedProfil = async () => {
        try {
            const result = await httpClient.post('/admin/members-added-profile-list', {

                id: id,

            }, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            })

            if (result.status === 200) {
                let week_arr = []
                console.log(result.data.data, 'data..')
                // setTotalCount(result?.data.total_count)

                setmemberAddedprofile(result?.data?.data)
                // setweeklyData(result?.data?.weekly_report_data)
            }

        } catch (error) {
            //   toast.error(error.message)
        }
    }
    return (

        <>
            <div className="header-back"
                onClick={() => navigate('/member', {
                    state: {
                        backpagi: location?.state?.paginationState
                    }
                })}
            >
                <div></div>
                <div className="back-button">
                    <i class="fa fa-arrow-left back-arrow-button"
                        // className="back-arrow-button"
                        aria-hidden="true"></i>
                </div>

            </div>
            <div className="row">
                <div className="card col-md-6">
                    <h5>Profile Details</h5>
                    <div className="acc-profile-image-section ">
                        {/* <div> */}
                        <p>Profile Image :</p>
                        {/* </div> */}
                        <div className="acc-details-image">
                            <div className="image-container">
                                <img
                                    className="image-acc-details"
                                    src={accouuntDetaila?.profile_photo_url !== null ?

                                        accouuntDetaila?.profile_photo_url : noimage
                                    }></img>
                            </div>

                            {/* <div>

                                <span className={accouuntDetaila?.active == 1 ? "active_profile" : "inactive_profile"}>{accouuntDetaila?.active == 1 ? "Active" : "Inactive"}</span>
                            </div> */}
                        </div>
                    </div>
                    <div className="account-details" style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between'
                    }}>
                        <div>
                            <p>Name : {accouuntDetaila?.name} </p>
                            {/* <p className="ml-2"></p> */}
                        </div>



                        <div>

                            <span className={accouuntDetaila?.active == 1 ? "active_profile" : "inactive_profile"}>{accouuntDetaila?.active == 1 ? "Active" : "Inactive"}</span>
                        </div>



                    </div>
                    {/* <div className="account-details">
                                           <p>Email : </p>
                                           <p className="ml-2"> {accouuntDetaila?.email}</p>
                                       </div> */}
                    <div className="account-details">
                        <p>Phone : </p>
                        <p className="ml-2">{accouuntDetaila?.phone}</p>
                    </div>
                    <div className="account-details">
                        <p>Member Id : </p>
                        <p className="ml-2">{accouuntDetaila?.user_referral_code}</p>
                    </div>
                    <div className="account-details">
                        <p>Joining Date : </p>
                        <p className="ml-2">{accouuntDetaila?.joing_date !== null ?
                            moment(accouuntDetaila?.joing_date).format('DD-MM-YYYY') : null}</p>
                    </div>
                    <div className="account-details">
                        <p>Refered By : </p>
                        <p className="ml-2">{accouuntDetaila?.referral_code !== null ?
                            accouuntDetaila?.referral_code : null}</p>
                    </div>
                    <div className="account-details" style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between'
                    }}>
                        <p>Depth Line : <span style={{ color: 'green' }}> {uplineData?.length} </span></p>

                        <button type="button" class="btn btn-primary" data-toggle="modal" data-target=".bd-example-modal-lg">Check UP-line</button>

                    </div>
                    <div className="addres-account-details">
                        <p>Address:
                            {`${accouuntDetaila?.state_name !== null ? `${accouuntDetaila?.state_name},` : ''}
                                            ${accouuntDetaila?.district_name !== null ? `${accouuntDetaila?.district_name},` : ''} 
                                            ${accouuntDetaila?.city !== null ? `${accouuntDetaila?.city},` : ''}
                                            ${accouuntDetaila?.pin_code !== null ? `${accouuntDetaila?.pin_code}` : ''}`}
                        </p>
                    </div>
                    <div className="account-details" style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        flexDirection: 'row'
                    }}>
                        <p>Position : </p>
                        <button type="button"
                            style={{
                                backgroundColor: accouuntDetaila?.active == 1 ? 'green' : 'red',
                                border: 'none',
                                fontSize: 12,
                                color: 'white'
                            }}
                            data-toggle="modal" data-target=".bd-example-modal-lg">{accouuntDetaila?.position !== null ?
                                accouuntDetaila?.position : null}</button>

                        {/* <h6 className="ml-2 user-position" style={{
                                               backgroundColor: accouuntDetaila?.active == 1 ? 'green' : 'red'
                                           }}
                   
                                           >{accouuntDetaila?.position !== null ?
                                               accouuntDetaila?.position : null}</h6> */}
                    </div>
                    <div className="account-details">
                        <p>Become Active On : {moment(accouuntDetaila?.member_active_date).format('DD-MM-YYYY')}</p>
                        {/* <p className="ml-2">{accouuntDetaila?.referral_code !== null ?
                                                                   accouuntDetaila?.referral_code : null}</p> */}
                    </div>
                    <div className="account-details">
                        <p>Last Open On :  {accouuntDetaila?.last_login && moment(accouuntDetaila?.last_login).format('DD-MM-YYYY')}  {accouuntDetaila?.last_login && moment(accouuntDetaila?.last_login).format('LT')}</p>

                        {/* <p>Last Active On : {
                                             
                                             moment(accountDetails?.last_login).format('DD-MM-YYYY')}  {moment(accountDetails?.last_login).format('LT')
                                             
                                             }</p> */}
                        {/* <p className="ml-2">{accouuntDetaila?.referral_code !== null ?
                                                                   accouuntDetaila?.referral_code : null}</p> */}
                    </div>

                    {
                        accouuntDetaila?.adrress_1 !== null ?
                            <div className="account-details">
                                <p>Addres 2 : </p>
                                <p className="ml-2">{accouuntDetaila?.adrress_1}</p>
                            </div>
                            :
                            null

                    }
                    {
                        accouuntDetaila?.adrress_1 !== null ?
                            <div className="account-details">
                                <p>Addres 2 : </p>
                                <p className="ml-2">{accouuntDetaila?.adrress_1}</p>
                            </div>
                            :
                            null

                    }



                    {/* <div className="account-details">
                        <p>PIN Code : </p>
                        <p>{accouuntDetaila?.pin_code}</p>
                    </div> */}
                    {/* <div className="account-details">
                        <p>DOB : </p>
                        <p className="ml-2">{accouuntDetaila?.dob}</p>
                    </div> */}



                    <div>
                    </div>
                </div>
                <div className="card  col-md-6">
                    <h5>Account Details & Others Details</h5>


                    {
                        bank_details?.map((bank) => {
                            return (
                                <>
                                    <div className="account-details" style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'flex-start',
                                        alignItems: 'flex-start'
                                    }}>
                                        <div style={{
                                            display: 'flex',
                                            flexDirection: 'row'
                                        }}>
                                            <p>Account Holder Name : </p>
                                            <p className="ml-2">{bank?.account_holder_name !== null ?
                                                bank?.account_holder_name : null}</p>
                                        </div>
                                        <div style={{
                                            display: 'flex',
                                            flexDirection: 'row'
                                        }}>
                                            <p>Bank Name : </p>
                                            <p className="ml-2">{bank?.bank_name !== null ?
                                                bank?.bank_name : null}</p>
                                        </div>
                                        <div style={{
                                            display: 'flex',
                                            flexDirection: 'row'
                                        }}>
                                            <p>Account Number : </p>
                                            <p className="ml-2">{bank?.account_no !== null ?
                                                bank?.account_no : null}</p>
                                        </div>
                                        <div style={{
                                            display: 'flex',
                                            flexDirection: 'row'
                                        }}>

                                            <p>IFSC Code : </p>
                                            <p className="ml-2">{bank?.ifsc_code !== null ?
                                                bank?.ifsc_code : null}</p>
                                        </div>
                                    </div>
                                </>
                            )
                        })
                    }

                    <h5 style={{
                        marginTop: 20
                    }}>User Address</h5>
                    <div className="addres-account-details">
                        <p>
                            {accouuntDetaila?.address}
                        </p>


                    </div>
                </div>

                <div className="card col-md-12" >

                    <h5>Service Used</h5>


                    <div className="table-responsive">
                        <table className="table">
                            <thead>
                                <tr>
                                    <th>SL NO</th>
                                    <th>Categoty</th>
                                    <th>Sub Categoty</th>
                                    <th>Buying Plan</th>
                                    <th>Pay Amount</th>
                                    <th>Buying Date</th>
                                    <th>Expire On</th>
                                    <th>Status</th>
                                    {/* <th>View Details</th> */}

                                </tr>
                            </thead>
                            <tbody>
                                {
                                    subscriptionList?.map((item, index) => {
                                        return (
                                            <>
                                                <tr key={index}>
                                                    <td>{index + 1}</td>
                                                    <td>{item?.category}</td>
                                                    <td>{item?.sub_category}</td>
                                                    <td>{item?.subscription_name}</td>
                                                    <td>{item?.amount}</td>



                                                    <td>{moment(item?.date).format('DD-MM-YYYY')}</td>
                                                    <td>{moment(item?.expiry_date).format('DD-MM-YYYY')}</td>
                                                    <td>{
                                                        new Date().toLocaleDateString('en-CA') > item?.expiry_date ? 'Expired' : 'Active'
                                                        // item?.current_status != 0 ? "Active" : 'Inactive'

                                                    }</td>
                                                    {/* <td>
                                                        {
                                                            item?.current_status != 0 && <div className="action" style={{
                                                                display: 'flex',
                                                                justifyContent: 'center',
                                                                alignItems: 'center'
                                                            }}>
                                                                <Link ><i class="fa fa-eye" aria-hidden="true"></i></Link>

                                                            </div>

                                                        }



                                                    </td> */}
                                                </tr>
                                            </>
                                        )
                                    })
                                }

                            </tbody>
                        </table>
                        {
                            subscriptionList?.length == 0 ?
                                <div className="nodata-found-div">
                                    <p>No Data Found</p>

                                </div>
                                :
                                null
                        }
                    </div>

                    <h5 style={{
                        marginTop: 30
                    }}>Profile Added </h5>


                    <div className="table-responsive">
                        <table className="table">
                            <thead>
                                <tr>
                                    <th>SL NO</th>
                                    <th>Categoty</th>
                                    <th>Sub Categoty</th>
                                    <th>Buying Plan</th>
                                    <th>Pay Amount</th>
                                    <th>Buying Date</th>
                                    <th>Expire On</th>
                                    <th>Status</th>
                                    <th>View Details</th>

                                </tr>
                            </thead>
                            <tbody>

                                {
                                    memberAddedlist?.map((item, index) => {
                                        return (
                                            <>
                                                <tr key={index}>
                                                    <td
                                                        style={{
                                                            backgroundColor: item?.renue_profile_count > 0 ? '#c0cfc4' : '',
                                                            color: '#000000',
                                                        }}
                                                    >{index + 1}</td>
                                                    <td style={{
                                                        backgroundColor: item?.renue_profile_count > 0 ? '#c0cfc4' : '',
                                                        color: '#000000',
                                                    }}>{item?.category}</td>
                                                    <td style={{
                                                        backgroundColor: item?.renue_profile_count > 0 ? '#c0cfc4' : '',
                                                        color: '#000000',
                                                    }}>{item?.sub_category}</td>
                                                    <td style={{
                                                        backgroundColor: item?.renue_profile_count > 0 ? '#c0cfc4' : '',
                                                        color: '#000000',
                                                    }}>{item?.subscription_name}</td>
                                                    <td style={{
                                                        backgroundColor: item?.renue_profile_count > 0 ? '#c0cfc4' : '',
                                                        color: '#000000',
                                                    }}>{item?.amount}</td>
                                                    <td style={{
                                                        backgroundColor: item?.renue_profile_count > 0 ? '#c0cfc4' : '',
                                                        color: '#000000',
                                                    }}>{moment(item?.date).format('DD-MM-YYYY')}</td>
                                                    <td style={{
                                                        backgroundColor: item?.renue_profile_count > 0 ? '#c0cfc4' : '',
                                                        color: '#000000',
                                                    }}>
                                                        {/* {
                                                        !['Rejected' ,'Blocked' ]?.includes( item?.current_profile_status) && (<> */}
                                                        {
                                                            item?.expiry_date != null &&
                                                            moment(item?.expiry_date).format('DD-MM-YYYY')
                                                        }
                                                        {/* </>) 
                                                       } */}
                                                    </td>
                                                    <td style={{
                                                        // color: item?.status == 3 ? 'red' : item?.current_status == 3 ? 'red' :
                                                        //     item?.status === 1
                                                        //         ? 'green'
                                                        //         : item?.status === 2
                                                        //             ? 'gray'

                                                        //             : item?.status === 3
                                                        //                 ? 'red' : item?.current_status === 0 ? 'Inactive' :
                                                        //                     new Date().toISOString().split('T')[0] == item?.expiry_date
                                                        //                         ? 'Expired'
                                                        //                         : ''
                                                        color: item?.current_profile_status == 'Pending' ? 'gray' :
                                                            item?.current_profile_status == 'Rejected' ? 'red' :
                                                                item?.current_profile_status == 'Active' ? 'green' :
                                                                    item?.current_profile_status == 'Blocked' ? 'red' :
                                                                        item?.current_profile_status == 'Disabled' ? 'Red' :
                                                                            item?.current_profile_status == 'Expired' ? 'red' : '',

                                                        backgroundColor: item?.renue_profile_count > 0 ? '#c0cfc4' : 'transparent',
                                                        // color : 'transparent',

                                                    }}>
                                                        {/* {
                                                            item?.status == 3 ? 'Blocked' : item?.current_status === 3
                                                                ? 'Disabled' : item?.expiry_status == 0 ? 'Expired' :
                                                                    item?.status === 1
                                                                        ? 'Active'
                                                                        : item?.status === 2
                                                                            ? 'Rejected'
                                                                            : item?.status === 0 ? 'Pending' :
                                                                                new Date().toISOString().split('T')[0] == item?.expiry_date
                                                                                    ? 'Expired'
                                                                                    : ''
                                                        } */}
                                                        <div>
                                                            {
                                                                item?.current_profile_status
                                                            }
                                                            {
                                                                item?.renue_profile_count > 0 && (
                                                                    <p style={{
                                                                        color: 'red'
                                                                    }}>Renew-{item?.renue_profile_count}</p>
                                                                )
                                                            }

                                                        </div>

                                                    </td>
                                                    <td style={{
                                                        backgroundColor: item?.renue_profile_count > 0 ? '#c0cfc4' : '',
                                                        color: '#000000',
                                                    }}>

                                                        {
                                                            item?.current_status != 0 && <div className="action" style={{
                                                                display: 'flex',
                                                                justifyContent: 'center',
                                                                alignItems: 'center'
                                                            }}>
                                                                <Link to={`/profile-request-details/${item?.business_account_id}`}><i class="fa fa-eye" aria-hidden="true"></i></Link>


                                                            </div>

                                                        }
                                                        {/* <div className="action" style={{
                                                            display: 'flex',
                                                            justifyContent: 'center',
                                                            alignItems: 'center'
                                                        }}>
                                                            <Link to={`/profile-request-details/${item?.id}`}><i class="fa fa-eye" aria-hidden="true"></i></Link>

                                                        </div> */}

                                                    </td>
                                                </tr>
                                            </>
                                        )
                                    })
                                }

                            </tbody>

                        </table>
                        {
                            profileSubsciption?.length == 0 ?
                                <div className="nodata-found-div">
                                    <p>No Data Found</p>

                                </div>
                                :
                                null
                        }
                    </div>


                    <div>
                        {/* <h5>Subscription Details</h5> */}




                    </div>
                    {/* </AccordionItemPanel>
                    </AccordionItem> */}


                </div>
                {/* <div className="card col-md-12">
                    <h5>Business Profile</h5>
                    <div className="row">


                        {
                            businessProfiles?.map((items, index) => {
                                return (
                                    <>
                                        <div className="col-md-3 business_profile m-2">
                                            <div className="business-profileitem-count">
                                                <p className="acc-details-color">{index + 1}</p>

                                            </div>
                                            <div className="bus-category">
                                                <p className="business-text">Category : {items?.category}</p>
                                                <p className="business-text">Sub-Category : {items?.sub_category}</p>
                                            </div>

                                            <div className="acc-d-field" >

                                                {
                                                    items?.field_data?.map((item) => {
                                                        return (
                                                            <>
                                                                
                                                                <ul className="items-business-list">
                                                                    <li className="">
                                                                        {item?.field_value !== 'file' ? item?.field_value : 'Image'}
                                                                    </li>
                                                                </ul>

                                                               
                                                            </>
                                                        )

                                                    })

                                                }
                                                
                                            </div>
                                            <div className="row business-images">

                                                {
                                                    items?.images?.image_path?.map((field) => {
                                                        return (
                                                            <div className="image-container">

                                                                <img className="image-acc-details" src={field} />
                                                            </div>
                                                        )
                                                    })


                                                }


                                            </div>

                                        </div>
                                    </>
                                )
                            })
                        }
                    </div>

                </div> */}

            </div>
            <div class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-lg">
                    <div class="modal-content" style={{
                        padding: 20
                    }}>
                        <div class="row">
                            <h5>Up Line Members</h5>
                            <div class="col-md-12">
                                <div class="table-responsive">
                                    <table class="table">
                                        <thead>
                                            <tr>
                                                <th>SL NO</th>
                                                <th> Member ID</th>
                                                <th>Name</th>
                                                {/* <th>Validity</th>
                            <th >Description</th> */}
                                                {/* <th>Discount</th>
                            <th>Price</th> */}

                                                <th>Mobile</th>
                                                <th>Address</th>
                                                <th>Joing Date</th>
                                                <th>Depth Line</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                uplineData?.map((item, index) => {
                                                    return (
                                                        <>
                                                            <tr>
                                                                <td
                                                                    style={{
                                                                        backgroundColor: item?.phone == null ? 'gray' : 'transparent',
                                                                        color: item?.phone == null ? 'white' : 'black'
                                                                    }}
                                                                >{index + 1}</td>

                                                                <td
                                                                    style={{
                                                                        backgroundColor: item?.phone == null ? 'gray' : 'transparent',
                                                                        color: item?.phone == null ? 'white' : 'black'
                                                                    }}
                                                                >{item?.member_code}</td>
                                                                <td
                                                                    style={{
                                                                        backgroundColor: item?.phone == null ? 'gray' : 'transparent',
                                                                        color: item?.phone == null ? 'white' : 'black'
                                                                    }}
                                                                >

                                                                    <div style={{ display: 'flex', flexDirection: 'column' }}>

                                                                        {item?.name}
                                                                        {item?.active == 1 ?
                                                                            <span className="ml-2 active_profile_table" style={{
                                                                                color: 'green'
                                                                            }}>Active</span>
                                                                            :
                                                                            <span className="ml-2 inactive_profile_table" style={{
                                                                                color: 'red'
                                                                            }}>Inactive</span>
                                                                        }
                                                                    </div>
                                                                </td>
                                                                <td
                                                                    style={{
                                                                        backgroundColor: item?.phone == null ? 'gray' : 'transparent',
                                                                        color: item?.phone == null ? 'white' : 'black'
                                                                    }}
                                                                >{item?.phone}</td>
                                                                <td
                                                                    style={{
                                                                        backgroundColor: item?.phone == null ? 'gray' : 'transparent',
                                                                        color: item?.phone == null ? 'white' : 'black'
                                                                    }}
                                                                >{item?.address !== null ? item?.address : '--'}</td>
                                                                <td
                                                                    style={{
                                                                        backgroundColor: item?.phone == null ? 'gray' : 'transparent',
                                                                        color: item?.phone == null ? 'white' : 'black'
                                                                    }}
                                                                >{moment(item?.joing_date).format('DD-MM-YYYY')}</td>
                                                                <td
                                                                    style={{
                                                                        backgroundColor: item?.phone == null ? 'gray' : 'transparent',
                                                                        color: item?.phone == null ? 'white' : 'black'
                                                                    }}
                                                                >{item?.level}</td>
                                                            </tr>
                                                        </>
                                                    )
                                                })
                                            }


                                        </tbody>

                                    </table>
                                    <div className='nodata-found-div'>
                                        {
                                            uplineData?.length == 0 ?
                                                <p>No Data Found</p>
                                                //  <img 
                                                //  className='table-image'
                                                //  src={require('../../assets/OIP.png')}/>
                                                : null
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default MemberProfileView


// images: {
//     image_path: "https://digihelp.acuitysoftware.in/admin/storage/app/public/account_images/1724225267-5226.jpg"

// }
